import trainingRouteManifest from './trainingRouteManifest.json';
import { TRAINING_LOCALES } from './trainingOffers';

const catalogueRoutes = new Map(
  Object.entries(trainingRouteManifest.catalogues).map(([locale, path]) => [path, locale]),
);

const offerRoutes = new Map(
  Object.entries(trainingRouteManifest.offers).flatMap(([offerKey, paths]) => (
    Object.entries(paths).map(([locale, path]) => [path, { locale, offerKey }])
  )),
);

const normalizePathname = (pathname) => (
  typeof pathname === 'string' && pathname.endsWith('/') ? pathname.slice(0, -1) : pathname
);

const getPathLocale = (pathname) => (pathname.startsWith('/en/') ? 'en' : 'fr');

export const getCataloguePath = (locale) => (
  TRAINING_LOCALES.includes(locale) ? trainingRouteManifest.catalogues[locale] : undefined
);

export const getOfferPath = (locale, key) => (
  TRAINING_LOCALES.includes(locale) ? trainingRouteManifest.offers[key]?.[locale] : undefined
);

export const resolveTrainingRoute = (pathname) => {
  const normalizedPathname = normalizePathname(pathname);

  if (catalogueRoutes.has(normalizedPathname)) {
    return { type: 'catalogue', locale: catalogueRoutes.get(normalizedPathname) };
  }

  const offerRoute = offerRoutes.get(normalizedPathname);
  if (offerRoute) {
    return { type: 'offer', ...offerRoute };
  }

  return { type: 'not-found', locale: getPathLocale(normalizedPathname || '') };
};

export const getAlternatePaths = (pathname) => {
  const route = resolveTrainingRoute(pathname);

  if (route.type === 'not-found') {
    return undefined;
  }

  if (route.type === 'catalogue') {
    return {
      fr: trainingRouteManifest.catalogues.fr,
      en: trainingRouteManifest.catalogues.en,
      xDefault: trainingRouteManifest.catalogues.fr,
    };
  }

  const paths = trainingRouteManifest.offers[route.offerKey];
  return { fr: paths.fr, en: paths.en, xDefault: paths.fr };
};
